'use client'

import { useEffect, useState } from 'react'
import { useTheme } from 'next-themes'
import { cn } from '@/lib/utils'

export default function BlogLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const { theme, resolvedTheme } = useTheme()
  const [isDark, setIsDark] = useState(false)

  useEffect(() => {
    const t = resolvedTheme || theme
    setIsDark(t === 'dark')
  }, [theme, resolvedTheme])

  return <div className={cn('min-h-screen', 'bg-background')}>{children}</div>
}
